<script lang='ts' setup>
import ArticleCard from '@/components/ArticleCard'
import type {ArticlesCollectionItem} from "@nuxt/content";
import {useArticlesPage} from "~/composables/articles";

definePageMeta({
  layout: 'custom',
  title: '首页'
})

const { themeColor } = useTheme()
const filterInfo = reactive<Pick<ArticlesCollectionItem, 'title'|'tags'>>({
  title: '',
  tags: []
})

const { pageList, refresh, hotList, lasterList, tagsList } = await useArticlesPage(filterInfo)

const nuxtApp = useNuxtApp()
const { data: userInfo } = useAsyncData('userInfo', () => {
  return nuxtApp.$fetch('/api/auth/userInfo', { method: 'get' })
})

watchEffect(() => {
  console.log(userInfo, '+++++++++++++++++=================================')
})

</script>

<template>
  <div class="home-page flex flex-col items-center">
    <div class="w-1200px">
      <div class="banner gap-col-20 flex mt-30px mb-30px pt-60px pb-60px pl-40px pr-40px">
        <div class="user-info flex-1 flex flex-col flex-shrink-0">
          <a-avatar class="mb-8" :style="{ background: 'var(--icon-bg)' }"
            :size="{ xs: 24, sm: 32, md: 40, lg: 64, xl: 90, xxl: 120 }">
            <template #icon>
              <SketchOutlined />
<!--              <img style="width: 100%;height: 100%;" src="~/assets/images/logo.png" alt="">-->
            </template>
          </a-avatar>
          <div>
            <div class="text-28px mb-4 font-700" :style="{ color: 'var(--title-color)' }">张三的博客</div>
            <p class="text-16px" :style="{ color: 'var(--text-color)' }">全栈开发工程师 | 技术分享者 | 开源爱好者</p>
          </div>
          <div>
            <p class="mt-8 mb-8 text-16px line-height-relaxed" :style="{ color: 'var(--text-color)' }">
              专注于Web前端、后端开发和云计算技术，分享学习心得和实践经验。</p>
            <div class="flex gap-col-8">
              <div class="line-height-snug">
                <p class="text-10 font-700" :style="{ color: 'var(--bold-color)' }">120+</p>
                <p class="mb-4 text-14px" :style="{ color: 'var(--text-color)' }">文章</p>
              </div>
              <div class="line-height-snug">
                <p class="text-10 font-700" :style="{ color: 'var(--bold-color)' }">120K+</p>
                <p class="mb-4 text-14px" :style="{ color: 'var(--text-color)' }">阅读量</p>
              </div>
              <div class="line-height-snug">
                <p class="text-10 font-700" :style="{ color: 'var(--bold-color)' }">5年+</p>
                <p class="mb-4 text-14px" :style="{ color: 'var(--text-color)' }">经验</p>
              </div>
            </div>
          </div>
        </div>
        <div class="system-info flex-2 flex-shrink-0">
          <div class="text-42px text-liner line-height-loose "
            :class="{ 'text-liner-light': themeColor !== 'dark' }">
            探索技术的无限可能</div>
          <p class="text-18px line-height-relaxed">分享前沿技术、实用经验和创新思考，让编程更简单，让技术更有趣。</p>
          <div class="p-20px mt-20px b-rd-8px" :style="{ background: 'var(--code-bg)' }">
            <code lang="javaScript" class="text-16px line-height-normal">
      <p style="color: #6272a4">// 代码是我的生活方式</p>
      <p><span style="color: #ff79c6">function</span> createFuture() {</p>
      <p><span style="color: #ff79c6">const</span> passion = "编程";</p>
      <p><span style="color: #ff79c6">const</span> hardwork = "持续学习";</p>
      <p><span style="color: #ff79c6">const</span> sharing = "知识分享";</p>
      <p style="color: #6272a4">// 技术改变世界</p>
      <p><span style="color: #ff79c6">return</span> passion + hardwork + sharing;</p>
      }
    </code>
          </div>
        </div>
        <div class="decoration-circle decoration-1"></div>
        <div class="decoration-circle decoration-2"></div>
      </div>
      <div class="flex">
        <div class="flex-1">
          <h2 class="text-24px font-700 mb-vh-20px" :style="{ color: 'var(--title-color)' }"><i>
              <FileTextOutlined :style="{ color: 'var(--bold-color)', marginRight: '12px' }" />
            </i>最新文章</h2>
          <div class="article-list grid grid-cols-2 gap-col-8 pr-vh-20px gap-row-6">
            <ArticleCard v-for="(article, index) in lasterList" :key="index" :article="article"></ArticleCard>
          </div>
        </div>
        <div class="bl-1-solid w-360px flex-shrink-0 pl-vh-20px"
          :style="{ 'border-color': 'var(--border-color)' }">
          <div class="mb-vh-60px">
            <a-input v-model:value="filterInfo.title" @change="refresh()" placeholder="请输入文章关键字">
              <template #suffix>
                <a-tooltip title="搜索文章">
                  <SearchOutlined :style="{ color: 'var(--bold-color)' }" />
                </a-tooltip>
              </template>
            </a-input>
          </div>
          <div class="mb-vh-60px">
            <h2 class="text-24px font-700 mb-vh-20px" :style="{ color: 'var(--title-color)' }"><i>
                <TagOutlined :style="{ color: 'var(--bold-color)', marginRight: '12px' }" />
              </i>分类标签</h2>
            <div>
              <BaseTag type="round" v-model="filterInfo.tags as string[]" @tag-change="refresh()" :is-click="true" :name="tagsList"></BaseTag>
            </div>
          </div>
          <div class="mb-vh-60px">
            <h2 class="text-24px font-700 mb-vh-20px" :style="{ color: 'var(--title-color)' }"><i>
                <FireOutlined :style="{ color: 'var(--bold-color)', marginRight: '12px' }" />
              </i>热门文章</h2>
            <div>
              <ArticleList :articles="hotList"></ArticleList>
            </div>
          </div>
          <div class="mb-vh-40px">
            <h2 class="text-24px font-700 mb-vh-20px" :style="{ color: 'var(--title-color)' }"><i>
                <UserOutlined :style="{ color: 'var(--bold-color)', marginRight: '12px' }" />
              </i>关于作者</h2>
            <div class="text-align-center p-20px b-rd-8px" :style="{ background: 'var(--code-bg)' }">
              <p>
                <a-avatar class="mb-8" :style="{ background: 'var(--icon-bg)' }" :size="60">
                  <template #icon>
                    <AntDesignOutlined />
                  </template>
                </a-avatar>
              </p>
              <p class="text-18px font-700 mb-vh-15px" :style="{ color: 'var(--title-color)' }">张三</p>
              <p class="text-14px line-height-normal mb-vh-15px">全栈开发工程师，拥有5年+开发经验。热爱技术分享，专注于Web开发、云计算和人工智能领域。</p>
              <p><a-button type="primary">收藏博客</a-button></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang='scss' scoped>
.home-page {
  color: var(--text-color);

  .banner {
    background: var(--banner-bg);
    border-radius: 20px;
    position: relative;
    overflow: hidden;
  }

  .banner::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 400px;
    height: 400px;
    background: radial-gradient(circle, rgba(58, 123, 213, 0.1) 0%, rgba(58, 123, 213, 0) 70%);
    z-index: 0;
  }

  .banner::after {
    content: '';
    position: absolute;
    bottom: -100px;
    left: -100px;
    width: 300px;
    height: 300px;
    background: radial-gradient(circle, rgba(0, 210, 255, 0.1) 0%, rgba(0, 210, 255, 0) 70%);
    z-index: 0;
  }

  .decoration-1 {
    width: 300px;
    height: 300px;
    top: -150px;
    right: -150px;
  }

  .decoration-2 {
    width: 200px;
    height: 200px;
    bottom: -100px;
    left: -100px;
  }

  .decoration-circle {
    position: absolute;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(58, 123, 213, 0.2) 0%, rgba(58, 123, 213, 0) 70%);
  }

  .ant-input-affix-wrapper,
  :deep(.ant-input) {
    background: var(--code-bg);
    color: var(--text-color);
    border-color: var(--border-color);
  }

  :deep(.ant-input) {
    background: rgba(0, 0, 0, 0);
  }

  :deep(span:has(.ant-input:focus)) {
    box-shadow: none !important;
    border-color: var(--bold-color);
  }

  :deep(.ant-input::placeholder) {
    color: var(--text-color);
  }
}
</style>
